import { APICore } from "./apiCore";

const api = new APICore();

// category
function addCategory(params: { name: string; isCamp: any }) {
  const baseUrl = "/category";
  return api.create(`${baseUrl}`, params);
}

function getCategory() {
  const baseUrl = "/category";
  return api.get(`${baseUrl}`, {});
}

function updateCategory(id: number, params: { name: string; isCamp: any }) {
  const baseUrl = `/category/${id}`;
  return api.update(`${baseUrl}`, params);
}

function deleteCategory(id: number) {
  const baseUrl = `/category/${id}`;
  return api.delete(`${baseUrl}`);
}

export { addCategory, getCategory, updateCategory, deleteCategory };
